import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router';
import React, { FC, useContext } from 'react';
import 'react-responsive-modal/styles.css';
import cn from 'classnames';
import { GxSpinner } from '@garpix/garpix-web-components-react';
import { api } from '@/api';
import styles from '../../styles/index.module.scss';
import StatisticSortMenu from './StatisticsSortmenu';
import DateFormat from '../../../../../../components/DateFormat';
import TimeFormat from '../../../../../../components/TimeFormat';
import { NAME_STATUS, TYPES_STATUS } from '../../../../consts';
import Pagination from '../../../../../../components/Pagination';
import { FETCHER_STATUS, ORDERS } from '../../../../../../const';
import { Context } from '../../Context';

const StatisticPanelTable: FC<any> = ({ userId }) => {
  const tableTh = [
    { id: 1, title: '№ заявки' },
    { id: 2, title: 'Дата' },
    { id: 3, title: 'Время' },
    { id: 4, title: 'Участники' },
    { id: 5, title: 'Тариф' },
    { id: 6, title: 'Стоимость' },
    { id: 7, title: 'Оплачено' },
    { id: 8, title: 'Статус' },
  ];
  const [handleClickModal] = useContext<any>(Context);

  return (
    <div className={styles['orders']}>
      <h2 className={styles['orders--title']}>Заявки</h2>
      {userId ? (
        <FetcherList
          api={api.order.getOrders}
          isHistoryPush={false}
          initFilter={{ customer: userId, limit: 10, side: 1 }}
        >
          {({
            results = [],
            count,
            filterParams,
            activePage,
            loadData,
            status,
            otherData,
          }: any) => {
            const isLoading = status === FETCHER_STATUS.loading;
            const isLoaded = status === FETCHER_STATUS.loaded;
            const isNotFounded =
              isLoaded && results.length === 0 && filterParams.end_date;
            return (
              <>
                <StatisticSortMenu
                  filterParams={filterParams}
                  loadData={loadData}
                />
                <div className={styles['table']}>
                  <table>
                    <thead>
                      <tr>
                        <th>N Заявки</th>
                        <th>Дата</th>
                        <th>Время</th>
                        <th>
                          {filterParams.side === ORDERS.PIPE
                            ? 'Минуты'
                            : 'Кол-во сетов'}
                        </th>
                        <th>Тариф</th>
                        <th>Стоимость</th>
                        <th>Оплачено</th>
                        <th>Статус</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isNotFounded && (
                        <tr>
                          <td className={styles['table--empty']} colSpan={8}>
                            Ничего не найдено.
                          </td>
                        </tr>
                      )}
                      {isLoading && (
                        <tr>
                          <td className={styles['table--loading']} colSpan={8}>
                            <GxSpinner />
                          </td>
                        </tr>
                      )}
                      {isLoaded &&
                        results.map((order: Record<string, any>) => {
                          const {
                            id,
                            number,
                            start_at,
                            tariff,
                            status,
                            side,
                            price,
                            price_paid,
                            deposit_sets_paid,
                            certificate_name,
                            deposit_name,
                            certificate_mins_paid,
                            certificate_sets_paid,
                            deposit_mins_paid,
                            session_minutes,
                            count_party,
                          } = order;
                          return (
                            <tr key={id}>
                              <td
                                className={styles['order-name']}
                                onClick={() =>
                                  handleClickModal(start_at, order)
                                }
                              >
                                № {number}
                              </td>
                              <td>
                                <DateFormat date={start_at} />
                              </td>
                              <td>
                                <TimeFormat time={start_at} />
                              </td>
                              <td>
                                {filterParams.side === ORDERS.PIPE
                                  ? session_minutes
                                  : count_party}
                              </td>
                              <td>{tariff?.title}</td>
                              <td>
                                {Math.trunc(price).toLocaleString()} &#8381;
                              </td>
                              {certificate_name && (
                                <td>{`${side === ORDERS.PIPE
                                  ? certificate_mins_paid
                                  : certificate_sets_paid
                                  } ${side === ORDERS.PIPE ? 'мин.' : 'сет(ов)'
                                  }`}</td>
                              )}
                              {deposit_name && (
                                <td>{`${side === ORDERS.PIPE
                                  ? deposit_mins_paid
                                  : deposit_sets_paid
                                  } ${side === ORDERS.PIPE ? 'мин.' : 'сет(ов)'
                                  }`}</td>
                              )}
                              {!certificate_name && !deposit_name && (
                                <td>{Math.trunc(price_paid)} &#8381;</td>
                              )}
                              <td>
                                <span
                                  className={cn(
                                    styles['table--status'],
                                    styles[
                                    `table--status-orders_${NAME_STATUS[TYPES_STATUS[status || 0]]
                                      .class
                                    }`
                                    ]
                                  )}
                                >
                                  {NAME_STATUS[TYPES_STATUS[status]].title}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className={styles['application-amount']}>
                  <div className={styles['application-amount--pagination']}>
                    {!!count && (
                      <Pagination
                        total={count}
                        pageSize={10}
                        onChange={(page: number) =>
                          loadData(page, filterParams)
                        }
                        activePage={activePage}
                      />
                    )}
                  </div>
                  <div className={styles['application-amount--info']}>
                    {otherData?.resource_sum && <div>
                      <div className={styles['application-amount--label']}>
                        Общий ресурс:
                      </div>
                      <div className={styles['application-amount--price']}>
                        {Math.trunc(otherData?.resource_sum).toLocaleString() || 0}
                        {filterParams.side === ORDERS.PIPE ? ' мин' : ' сеты'}
                      </div>
                    </div>
                    }
                    <div>
                      <div className={styles['application-amount--label']}>
                        Заявки на сумму:
                      </div>
                      <div className={styles['application-amount--price']}>
                        {Math.trunc(otherData?.price_sum).toLocaleString() || 0} ₽
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          }}
        </FetcherList>
      ) : (
        <>
          <StatisticSortMenu isDisabled />
          <div className={styles['table']}>
            <table>
              <thead>
                <tr>
                  {tableTh.map(({ id, title }) => {
                    return <th key={id}>{title}</th>;
                  })}
                </tr>
              </thead>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default StatisticPanelTable;
